import SchoolIcon from '@mui/icons-material/School';
import StorageIcon from '@mui/icons-material/Storage';
import WorkIcon from '@mui/icons-material/Work';
import Timeline from '@mui/lab/Timeline';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import * as React from 'react';

export default function CustomizedTimeline() {
  return (
    <Timeline position="alternate">
        <TimelineItem>
            <TimelineOppositeContent
                sx={{ m: 'auto 0', opacity: 0.7 }}
                align="right"
                variant="body2"
            >
                June 2026 - present
            </TimelineOppositeContent>
            <TimelineSeparator>
            <TimelineConnector />
            <TimelineDot color="primary">
                <WorkIcon />
            </TimelineDot>
            <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent sx={{ py: '12px', px: 2 }}>
            <Typography variant="h6" component="span">
                <Link href="https://www.trentinodigitale.it/" underline="none" target="_blank" rel="noopener" color="inherit">
                    {'Trentino Digitale'}
                </Link>
            </Typography>
            <Typography>Data Center System Administrator</Typography>
            </TimelineContent>
        </TimelineItem>


        <TimelineItem>
            <TimelineOppositeContent
                sx={{ m: 'auto 0', opacity: 0.7 }}
                align="right"
                variant="body2"
            >
                May 2026 - June 2026
            </TimelineOppositeContent>
            <TimelineSeparator>
            <TimelineConnector />
            <TimelineDot>
                <WorkIcon />
            </TimelineDot>
            <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent sx={{ py: '12px', px: 2 }}>
            <Typography variant="h6" component="span">
                <Link href="https://cloudfabric.it" underline="none" target="_blank" rel="noopener" color="inherit">
                    {'Cloudfabric'}
                </Link>
            </Typography>
            <Typography>System Administrator</Typography>
            </TimelineContent>
        </TimelineItem>

        <TimelineItem>
            <TimelineOppositeContent
                sx={{ m: 'auto 0', opacity: 0.7 }}
                align="right"
                variant="body2"
            >
                2025 - present
            </TimelineOppositeContent>
            <TimelineSeparator>
            <TimelineConnector />
            <TimelineDot color="primary">
                <WorkIcon />
            </TimelineDot>
            <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent sx={{ py: '12px', px: 2 }}>
            <Typography variant="h6" component="span">
                <Link href="https://www.fbk.eu/" underline="none" target="_blank" rel="noopener" color="inherit">
                    {'Fondazione Bruno Kessler - FBK'}
                </Link>
            </Typography>
            <Typography>Intership</Typography>
            </TimelineContent>
        </TimelineItem>

        <TimelineItem>
            <TimelineOppositeContent
                sx={{ m: 'auto 0', opacity: 0.7 }}
                align="right"
                variant="body2"
            >
                2023 - 2024
            </TimelineOppositeContent>
            <TimelineSeparator>
            <TimelineConnector />
            <TimelineDot>
                <StorageIcon />
            </TimelineDot>
            <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent sx={{ py: '12px', px: 2 }}>
            <Typography variant="h6" component="span">
                <Link href="https://protonhost.cloud" underline="none" target="_blank" rel="noopener" color="inherit">
                    {'Protonhost'}
                </Link>
            </Typography>
            <Typography>Founder</Typography>
            </TimelineContent>
        </TimelineItem>

        <TimelineItem>
            <TimelineOppositeContent
                sx={{ m: 'auto 0', opacity: 0.7 }}
                variant="body2"
            >
                2022 - present
            </TimelineOppositeContent>
            <TimelineSeparator>
            <TimelineConnector />
            <TimelineDot color="primary">
                <SchoolIcon />
            </TimelineDot>
            <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent sx={{ py: '12px', px: 2 }}>
            <Typography variant="h6" component="span">
                <Link href="https://www.unitn.it/en" underline="none" target="_blank" rel="noopener" color="inherit">
                    {'University of Trento'}
                </Link>
            </Typography>
            <Typography>Computer Science</Typography>
            </TimelineContent>
        </TimelineItem>

        <TimelineItem>
            <TimelineOppositeContent
                sx={{ m: 'auto 0', opacity: 0.7 }}
                align="right"
                variant="body2"
            >
                2017 - 2022
            </TimelineOppositeContent>
            <TimelineSeparator>
            <TimelineConnector />
            <TimelineDot>
                <SchoolIcon />
            </TimelineDot>
            <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent sx={{ py: '12px', px: 2 }}>
            <Typography variant="h6" component="span">
                <Link href="https://www.itiseveripadova.edu.it/" underline="none" target="_blank" rel="noopener" color="inherit">
                    {'ITI Francesco Severi di Padova'}
                </Link>
            </Typography>
            <Typography>Diploma, Computer Science</Typography>
            </TimelineContent>
        </TimelineItem>
    </Timeline>
  );
}